import React from "react";

import { Typography } from "../Typography";
import { useTheme } from "../../utils/theme";

import type { StyleProp, TextStyle } from "react-native";
import type { TypographyProps } from "../Typography";

interface DialogDescriptionProps extends TypographyProps {
  children: string | React.ReactElement;
  style?: StyleProp<TextStyle>;
}

export function DialogDescription({
  children,
  accessibilityLabel,
  style,
  ...props
}: DialogDescriptionProps) {
  const { spacing } = useTheme();

  if (typeof children === "string") {
    return (
      <Typography
        focusable={true}
        color="dialogTextDescription"
        style={[{ textAlign: "center", marginVertical: spacing.lg }, style]}
        {...props}
        numberOfLines={10}
        accessibilityLabel={accessibilityLabel}
      >
        {children}
      </Typography>
    );
  }
  return children;
}
